import {appEnv} from '@/appEnv'
import {getWsLoggingParams} from '@repo/shared/Customer/Coop/utils/backendLogging'
import {isEventGameCode} from '@repo/shared/Customer/Coop/utils/gameCodeTypes'

export const getWSUrl = (gameCode: number) => {
  const url = isEventGameCode(gameCode) ? appEnv.WS_DISTRIBUTED_URL : appEnv.WS_URL

  const search = getWsLoggingParams({version: appEnv.VERSION})
  search.set('mode', 'bigscreen')
  search.set('gameCode', gameCode.toString())

  return `${url}?${search}`
}
